module.exports = __webpack_public_path__ + "img/jiangjin.c5fe7c07.svg";